const values = state => state.values;
const success = state => state.success;
const fetching = state => state.fetching;
const error = state => state.error;

export default {
  values,
  success,
  fetching,
  error,
};
